// SOPsTab.js
// Extracted from AIWorkforcePage.js for better maintainability

import { TabsContent } from '../../../components/ui/tabs';
import { Card, CardContent } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { Plus, FileText, Bot, Eye } from 'lucide-react';

export const SOPsTab = ({
  sops = [],
  onAddSOP,
  onEditSOP
}) => {
  return (
    <TabsContent value="sops" className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold">Standard Operating Procedures</h3>
          <p className="text-sm text-muted-foreground">Workflows and procedures for AI agents</p>
        </div>
        <Button onClick={onAddSOP} data-testid="add-sop-btn">
          <Plus className="h-4 w-4 mr-2" />
          Add SOP
        </Button>
      </div>

      <Card>
        <CardContent className="pt-6">
          <div className="space-y-4">
            {sops.map(sop => (
              <div 
                key={sop.id} 
                className="p-4 border rounded-lg hover:bg-slate-50 cursor-pointer hover:shadow-sm transition-all"
                onClick={() => onEditSOP(sop)}
                data-testid={`sop-item-${sop.id}`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-2">
                      <h4 className="font-semibold flex items-center gap-2">
                        {sop.name}
                        <Eye className="h-3 w-3 text-muted-foreground" />
                      </h4>
                      <Badge className={sop.status === 'active' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100'}>{sop.status}</Badge>
                      <Badge variant="outline">v{sop.version}</Badge>
                    </div>
                    <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{sop.description}</p>
                    <div className="flex gap-2 mt-2 flex-wrap">
                      {sop.agent_roles?.map((role, i) => (
                        <Badge key={i} variant="outline" className="text-xs">{role}</Badge>
                      ))}
                      {sop.assigned_agents?.length > 0 && (
                        <Badge className="bg-violet-100 text-violet-700 text-xs flex items-center gap-1">
                          <Bot className="h-3 w-3" /> {sop.assigned_agents.length} agents
                        </Badge>
                      )}
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium">{sop.steps?.length || 0} steps</p>
                    <p className="text-xs text-muted-foreground">Trigger: {sop.trigger_type}</p>
                  </div>
                </div>
              </div>
            ))}
            {sops.length === 0 && (
              <div className="text-center py-8 border-2 border-dashed rounded-lg">
                <FileText className="h-8 w-8 mx-auto text-muted-foreground mb-2" />
                <p className="text-muted-foreground mb-3">No SOPs defined yet</p>
                <Button size="sm" onClick={onAddSOP}>
                  <Plus className="h-4 w-4 mr-1" />
                  Create First SOP
                </Button>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  );
};

export default SOPsTab;
